const NOTIFICATION_TYPES = ["polite", "assertive"];

export { NOTIFICATION_TYPES };
